<app-base-modal
  [title]="title"
  titleColor="var(--color-evergreen)"
  closeIconColor="var(--color-evergreen)"
  [showCloseIcon]="!data.blocking"
  [gradientBackground]="backgroundGradient"
  (closed)="snooze()"
>
  <p class="update-modal-body">{{ body }}</p>

  <div actions class="update-modal-actions">
    <button
      *ngIf="!data.blocking"
      type="button"
      class="update-modal-pill"
      [style.background]="secondaryColor"
      [style.color]="secondaryTextColor"
      (click)="snooze()"
    >
      {{ secondaryLabel }}
    </button>
    <button
      type="button"
      class="update-modal-pill"
      [style.background]="primaryColor"
      [style.color]="primaryTextColor"
      (click)="updateNow()"
    >
      {{ primaryLabel }}
    </button>
  </div>
</app-base-modal>
